// SPDX-License-Identifier: AGPL-3.0-or-later
import styles from '@app/features/theme/styles/Message.module.css';
import {clsx} from 'clsx';
import {forwardRef, type HTMLAttributes} from 'react';

/** Shared message grid, also usable without an authenticated message model. */
export const MessageSurface = forwardRef<
	HTMLDivElement,
	HTMLAttributes<HTMLDivElement> & {layout?: 'cozy' | 'compact'}
>(function MessageSurface({className, layout = 'cozy', ...props}, ref) {
	return (
		<div
			{...props}
			ref={ref}
			className={clsx(layout === 'compact' ? styles.messageCompact : styles.message, className)}
		/>
	);
});
